import { render, staticRenderFns } from "./SuggestionTitle.vue?vue&type=template&id=38736452&scoped=true"
import script from "./SuggestionTitle.vue?vue&type=script&lang=js"
export * from "./SuggestionTitle.vue?vue&type=script&lang=js"
import style0 from "./SuggestionTitle.vue?vue&type=style&index=0&id=38736452&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38736452",
  null
  
)

export default component.exports